export const wallet = {
  wallet_deposits: "Depósitos",
  // withdrawal_info_phone: "Para asegurar que el dinero llegue a la cuenta correcta, debes asegurarte que el numero mostrado sea tu número de teléfono. ",
  // withdrawal_info_phone_2: "Este será el número al que enviaremos el dinero que solicitas.",
  // phone_number_registered: "Número de teléfono registrado: ",
  // accounts: {
  //   selectBank: "Seleccione el banco",
  //   phoneNumber: "Numero de teléfono: ",
  //   amount: "Monto: ",
  //   account: "Cuenta: ",
  //   noAccounts: "No has registrado cuentas",
  //   addAccountPagoMovil: "Agregar Cuenta Pago Movil",

  // },
  // yourBalance: "Saldo disponible: ",
  // notBalanceAvailable: "Saldo no disponible",
  // balanceInsufficient: "Saldo insuficiente",
  // isAmountEmpty: "Ingresa un monto",
  // areYouSure: "Estas seguro que quieres retirar ",
  // entityBank: "Entidad Bancaria",
  // phoneNumber: "Numero de teléfono",
  // amountWithdraw: "Monto a retirar",
  // withdrawTitle: "Retirar Dinero",
  // yourBalanceLeft: "Tu saldo restante sera: ",
  // movements: {
  //   deposits: "Depósitos",
  //   transfers: "Transferencias",
  //   withdrawals: "Retiros",
  //   plays: "Jugadas",
  // },
  // transactions: {
  //   sent: "Enviado a",
  //   received: "Recibido de ",
  //   rygBet: "Apuestas",
  //   rygWin: "Ganancias",
  //   rygRefund: "Reembolso",
  //   withdrawal: "Retiro",
  //   deposit: "Deposito",
  // }
};

export default wallet;
